import { gql, useQuery } from '@apollo/client';
import React, { ReactElement } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { DataView } from 'primereact/dataview';
import ReactMarkdown from 'react-markdown';

import Block from '../../Layout/Block';
import '../../Layout/Main.scss';
import '../../ProjectView/ProjectView.scss';
import '../../Table/Paginator.scss';
import './BautraegerInfo.scss';
import ProjectViewGridItem from '../../ProjectView/ProjectViewGridItem';
import ProjectViewSkeleton from '../../ProjectView/ProjectViewSkeleton';
import NotFound from '../../notFound';

const CUSTOMER_QUERY = gql`
  query customer($url: String!) {
    getPublicCustomer(url: $url) {
      abr
      description
      street
      zip
      city
      projects {
        id
        name
        address
        url
        zip
        city
        images {
          path
        }
      }
    }
  }
`;

interface MatchParams {
  url: string;
}

type BautraegerInfoProps = RouteComponentProps<MatchParams>;

const BautraegerInfo = (props: BautraegerInfoProps): ReactElement => {
  const { match } = props;
  const { url } = match.params;
  const { loading, data } = useQuery(CUSTOMER_QUERY, {
    variables: { url },
  });
  if (!loading && data && !data.getPublicCustomer) {
    return <NotFound />;
  }

  return (
    <div className="mainContent page bautraeger-container">
      <div className="p-grid">
        <div className="col-12 lg:col-4">
          <h1 className="bautraeger-name">{data?.getPublicCustomer?.abr}</h1>
          <h2 className="bautraeger-adresse">
            {data?.getPublicCustomer?.street &&
              `${data?.getPublicCustomer?.street}, `}{' '}
            {data?.getPublicCustomer?.zip} {data?.getPublicCustomer?.city}
          </h2>
        </div>
        <div className="col-12 lg:col-8">
          <Block>
            <ReactMarkdown>
              {data?.getPublicCustomer?.description}
            </ReactMarkdown>
          </Block>
        </div>
      </div>

      <div className="separator" />
      {loading || !data ? (
        <ProjectViewSkeleton />
      ) : (
        <DataView
          className="projectViewWrapper"
          value={data.getPublicCustomer?.projects}
          layout="grid"
          itemTemplate={ProjectViewGridItem}
          paginator={data.getPublicCustomer?.projects.length > 9}
          rows={9}
          emptyMessage="Keine Neubauprojekte verfügbar"
        />
      )}
    </div>
  );
};

export default BautraegerInfo;
